export const locale = {
  lang: 'zh2',
  data: {
    'REQUERIMIENTOS': {
      'BOTONES':{
        'SIGUIENTE':	'下一页',
        'ANTERIOR':	'上一页',
        'FINALIZAR':	'完成',
        'ACEPTAR': '我接受技术要求'
      },
      'MENSAJES': {
        'CONFREQ': '您已成功接受平台技术要求',
        'OK':'好',
      },
      'CABECERA':{
        'TITULO':	'IT 设置要求',
        'DESCRIP':	'',
      },
      'PASO1':{
        'TITULO':	'员工要求',
        'SUB_TITULO':	'1.申请条件',
        'SUB_TITULO2':	'2.浏览器容量要求',
        'TABLE_REQUERIMIENTOS' : {
          'TD_SISTEMAS':	'操作系统',
          'TD_LABEL_RECOMENDADO':	'或更高（推荐）',
          'TD_NAVEGADOR':	'浏览器',
          'TD_LABEL_SUPERIOR':	'或更高',
          'TD_LABEL_LASTVERSION':	'（最新版本）',
          'TD_LABEL_LASTVERSION_MIN':	'（最新版本，最低版本12.3）',
        },
        'TABLE_REQUISITOS' : {
          'TD_CERTIFICAR':	'安全证书',
          'TD_COOKIES':	'允许Cookie',
          'TD_CIFRADO':	'TLS加密',

          'TD_CONTENT1':	'为给予我们安全证书或授权, 请把Let\'s Encrypt Authority X3 归类为可靠机构',
          'TD_CONTENT2':	'浏览器必须启用JavaScript 1.2',
          'TD_CONTENT3':	'CulturalGo Platform服务器使用cookie，但不会从用户或其操作系统中收集信息。因调研操作需要，请务必启用。',
          'TD_CONTENT4':	'根据项目类型，我们的报告模块之一仅需要TLS加密',
        },
        'PARRAFO1': {
          'SUBPARRAFO1':	'如果客户打算使用其他操作系统，如LINUX，UNIX，ChromeOS或Mobile平台，则客户有责任确认调研于其浏览器中运作畅顺。',
          'SUBPARRAFO2':	'为堵塞POODLE漏洞（CVE-2014-3566）和Microsoft终止对Windows XP的支持，Great Place to Work 将不再全面支持运行Windows XP的计算机访问我们受保护的网站。 Windows XP计算机可使用应用程序要求中的Chrome或Firefox浏览器版本访问我们的网站。 其他浏览器或可访问网站； 但是，我们不提供对这些浏览器的测试或支持。',
        },
        'ADVERT': '注意：从Cultural Go版本5.0开始，将删除对Microsoft Internet Explorer的支持。'
      },
      'PASO2':{
        'TITULO':	'调研认证',
        'SUB_TITULO1':	'3.证书',
        'SUB_TITULO2':	'4.员工的笔记本计算机/ 台式机',
        'SUB_TITULO3':	'5.来自移动设备的调研回应',
        'SUB_TITULO4':	'1.要考虑的问题',
        'SUB_TITULO5':	'2.语言帮助',
        'PARRAFO1':	'Cultural GO使用Internet Security Research Group（ISRG）提供的Let\'s Encrypt Authority X3 SSL证书。如果未安装证书，则会向用户显示一个安全警告，通知该网站的安全证书有问题。用户可以选择继续访问网站或查看更多信息。但即使允许用户浏览网站，每次用户访问该网站时，警告消息仍会出现。',
        'PARRAFO2':{
          'LINEA1':	'为访问在线调研，员工的台式机/笔记本计算机需要：',
          'LINEA2':	'访问调研网站的完整权限（如果有防火墙的话, 请确保用户有适当的权限。）',
          'LINEA3':	'如调查链接已使用电邮发送，用户必须有权限访问其公司电子邮件帐户。',
        },
        'PARRAFO3':	'调查已在平板计算机和手机等移动设备上得到验证。 调查元素的显示和布置将与屏幕设备的分辨率匹配。 这取决于要执行调查的设备的型号。',

        'PARRAFO4':	'此调研界面的设计旨在为用户于高清移动设备的垂直屏幕上得到良好的用户体验。',

        'PARRAFO5':	'在一些组织中，个人设备或无法完全登入WiFi网络，因此，若用户决定使用个人设备并通过WiFi网络进行连接，请先验证是否拥有访问调研网站的权限。',

        'PARRAFO6':	'用户需注意，若使用手机直接连结，手机的网络供货商或会收取额外费用。',
        'PARRAFO7':{
          'LINEA1':	'用户将通过使用特定的URL来访问网站, 而 链接没有附带用户信息。',
          'LINEA2':	'必须在URL中输入独有的用户代码才能启用调研。',
          'LINEA3':	'各自独有的用户代码将通过电子邮件，SMS发送或通过人力资源部门（或同等职位）手动提供给用户。',
        },
        'PARRAFO8':{
          'LINEA1':	'1.客户需追踪发送电邮邀请予员工的情况：',
          'LINEA2':	'如果电子邮件服务器是外包的，请事先联系电子邮件提供商以告知要求。',
          'LINEA3':	'如果电子邮件服务器在其组织中，请向IT部门寻求支持。',
          'LINEA4':	'注意：在发送调研邀请时，不会发送至免费电邮的邮箱, 即：Hotmail，Gmail，Yahoo等。',
          'LINEA5':	'2.如果客户公司电子邮件为OUTLOOK WEBACCESS，请复制链接并在Web浏览器中打开，否则将产生错误。',
          'LINEA6':	'3.将进行中的调研闲置30分钟将视为“超时”，若想继续回答调研, 必须使用相同的用户名和密码重新登入。 登入后系统会把用户带到他们最后响应过的问题。',
          'LINEA7':	'选择答案后，会实时储存。在储存完成之前，用户将无法填答其他响应，藉以确保用户所有已填写的响应均已储存。',
        },
        'PARRAFO9':{
          'LINEA1':	'我们的调研仅支持在语言选择器中已设置的语言，并只能在调查开始前选定。',
          'LINEA2':	'如所选的语言是任何需要特殊字符的语言，用户请先确认其浏览器支持该字体。',
          'LINEA3':	'一般而言，所有东亚语言或其他需要特殊字符来查看调查问卷的用户都已安装语言包，因此除了少数用户外，大部分用户都不需要这样做。',
          'LINEA4':	'对于特定字体的要求，用户必须在各自的计算机上安装该字体。 而Great Place to Work 不论何时都能将此类要求传达给客户项目团队。',
        },
        'PARRAFO10':	'重要提示：用户必须确保浏览器没有开启自动翻译功能，否则，语言选择器可能无法正常运作。',
      },
      'PASO3':{
        'TITULO':	'互联网联机要求',
        'SUB_TITULO1':	'1. SSL加密要求',
        'SUB_TITULO2':	'2.带宽要求',
        'SUB_TITULO3':	'3.防火墙白名单：Web服务器IP和域访问',
        'SUB_TITULO4':	'4.防火墙白名单：电子邮件服务器',
        'SUB_TITULO5':	'5.生成回应组（Kioskos）',
        'PARRAFO1':	'客户端Web浏览器应支持启用SSL的网站。 这使用户可以最大程度地保护个人信息。',

        'PARRAFO2':	'带宽要求视乎调研和报告类型以及解决方案中使用的组件而定（视频，闪存和图像）。 对于具有这些组件的调研，建议的连接为每个用户1+ Mbit / s。 如使用较低的连接，可用性将受到影响。 对于不包含这些组件的调研，则只需要正常的网络连接。',

        'PARRAFO3':{
          'LINEA1':	'以下清单应列入白名单，以便调查和报告站点可于使用Cultural Go:',
          'LINEA2':	'请必须授予以下网域和IP地址必要权限，以便允许员工访问“Great Place to Work ®Trust Index”©调研。',
        },
        'PARRAFO31':	'重要提示：整个网域需要对用户设为可用（必须授予对整个站点的访问权限）',
        'PARRAFO4':{
          'LINEA1':	'邮件服务器需要授予对以下电邮地址的完全访问权限：',
          'LINEA2':	'必须为您的邮件服务器授予以下权限，以避免来自Great Place to Work的电子邮件被分类为垃圾邮件：',
        },
        'PARRAFO5':{
          'LINEA1':	'重要：',
          'LINEA2':	'此设置是为了避免电邮被检测为垃圾邮件',
          'LINEA3':	'邮件服务器必须能够从同一个账户获取数千封电子邮件',
          'LINEA4':	'在电子邮件供货商的安全规则中，添加要列入白名单的网域，并在可能的情况下将其添加为联系人电子邮件帐户',
        },
        'PARRAFO6':	'在不少组织，通常会设置多台式机，以便用户分组回答调研。 因此，有必要对输出到Internet的带宽进行测试，以确保连接设备将支持填写问卷时的流量。',
        'PARRAFO7':	'建议在用户分组回答之前，让IT部门确认互联网连接问题。',
        'TABLA1':{
          'TD_ELEMENTO':	'佩件',
          'TD_REGION1':	'墨西哥地区',
          'TD_REGION2':	'中南美地区',
          'TD_REGION3':	'亚洲地区',
          'TD_REGION4':	'欧洲地区',
          'TD_DOMINIO':	'域',
          'TD_SUBDOMINIO':	'子域',
          'TD_DIRECCION':	'IP方向',
          'TD_PUERTOS':	'连接口',

        },
        'TABLA2':{
          'TD1':	'发件人邮件账户：',
          'TD2':	'域',
        },
        'TABLADOMINIO':{
          'TD_ELEMENTO01':'应用',
          'TD_ELEMENTO02':'域名',
          'TD_ELEMENTO03':'网际协定',
          'TD_ELEMENTO04':'接口',
          'TD_ELEMENTO05':'子域名',
        },
        'TITLE1':'域 CulturalGo.com',
        'TITLE2':'域： gptw.global',
      },
      'PASO4':{
        'TITULO':	'服务水平',
        'SUB_TITULO1':	'1.支持',
        'SUB_TITULO2':	'2.系统可用性',
        'SUB_TITULO3':	'3.不可抗力',
        'SUB_TITULO4':	'4.同时发送',
        'SUB_TITULO5':	'5.系统维护',
        'TABLA1':{
          'TD_REGION1':	'墨西哥地区',
          'TD_REGION2':	'中南美地区',
          'TD_REGION3':	'亚洲地区',
          'TD_REGION4':	'欧洲地区',
        },
        'PARRAFO1':{
          'LINEA1':	'应用程序可用性= 99.5％',
          'LINEA2':	'为确保系统可用性，每年365天每周7天每天24小时监视该应用程序。 具有警报系统和支持程序。',
        },
        'PARRAFO2':	'不可抗力是指超出当事方合理控制范围的事件，其中不限于上帝的行为，战争，罢工，政府法规，内乱或恐怖主义或地震，这些行为使其在法律上不可行，非法或不可能 一方履行职责。',
        'PARRAFO3':	'系统可用性服务级别不涵盖由于客户未能满足此处列出的技术要求而导致的任何服务不足，或任何归类为不可抗力的事件',
        'PARRAFO4':	'数据收集系统能支持10,000个用户同时在线操作或在24小时内完成150万次调研。报告应用程序支持500个用户同时在线操作或在24小时内处理最多1,000个结果报告。',
        'PARRAFO5':{
          'LINEA1':	'Great Place to Work 保留将调查和报告应用程序关闭以进行定期维护的权利。预定的维护时间表将提前通知所有受影响的用户。',
          'LINEA2':	'在上述维护期间，用户可能无法使用应用程序。 如果Great Place to Work 需要延长维护时段，将通知相关的客户。',
          'LINEA3':	'在紧急维护下，维护时段可能不会另外通知。 但对于受紧急维护影响的客户，将收到特别通知。',
        },
      },
      'PASO5':{
        'TITULO':	'数据隐私政策',
        'SUB_TITULO1':	'1.政策',
        'PARRAFO1':	'发送和储存在CulturalGo平台服务器中的信息受到符合ISO 27001规定的政策和程序的保护和保障。如果您有任何疑问，请联系您的Great Place to Work顾问。',
      },
      'VALIDACION':{
        'TITULO': '技术要求验证',
        'DATOSTI':{
          'INFOEMPRESA': '公司信息',
          'NOMBREEMPRESA': '公司的名称',
          'NOMBRE': 'IT经理姓名',
          'EMAIL': 'IT电子邮件',
          'TEL': 'IT电话号码',
          'EXT': 'IT电话号码分机',
          'CEL': 'IT手机号码',
          'TOOLTIP': '显示公司信息',
        },
        'TIMELINE':{
          'TITULO': '技术要求确认过程',
          'CARGANDO': '加载信息',
          'PROGRESO': '现在的进展：',
          'PROGRESO2': '技术要求验证进度：',
          'STATUS': {
            'OK': '状态：已完成',
            'NOTOK': '状态：未完成',
            'TOOLTIP': '标记为完成',
          },
          'COMENTARIO': {
            'TITULO_1': '保存有关此步骤的评论',
            'INPUT': '输入您的评论',
            'ENVIAR': '保存评论',
            'TITULO_2': '评论（从最旧的开始）',
            'CANNOT': '步骤完成后便无法提交评论',
          },
          'NOMBRES': {
            '1': '电子邮件已发送给TI经理',
            '2': 'TR设置-客户致电',
            '3': 'TR设置-测试',
            '4': '问题单发送',
            '5': '问题单已完成',
          }
        },
        'MENSAJES': {
          'NADA': '您尚未输入评论，您可能无法保存空白评论',
          'AUNNO': '您尚无法执行此操作，必须先完成技术要求验证',
          'COMPLETAR': '您是否确认将此步骤的状态更改为“已完成”？',
          'COMPLETAR_OK': '此步骤已成功更改为“已完成”',
          'BOTONES': {
            'SI': '是',
            'NO': '没有',
          },
          'NOCOMPLETAR': '您可能尚未将此步骤标记为已完成，必须先完成上一步',
        }
      }
    },
    'REQUERIMIENTOSV3':{
      'MENSAJES':{
        'MENSAJE_SUCCESS_OK':'技术要求已更新',
        'MENSAJE_CONEX_OK':'连接成功',
        'ACTUALIZANDO_REQUERIMIENTOS': '更新技术要求',
        'MENSAJE_RESPUESTA_REQ':'* 需要回应',
        'WAR_ING_CORR':'输入至少一封电子邮件',
      },
      'CABECERA':{
        'TITULO': '技术要求',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
       'BOTONES':{
              'SIGUIENTE': '下一个',
              'ANTERIOR': '以前',
              'FINALIZAR': '完',
              'ACEPTAR': '我接受技术要求 '
            },
        'PASO1':{
          'TITULO':'贡献者要求',
          'SUB_TITULO':'技术要求',
          'SUB_TITULO2':'PlataformaCulturalGo®5.0',
          'TEXTO0_PARTE_1':'本文档旨在告知CulturalGo®平台的技术要求，以确保轻松有效地访问Greate Place toWork®，Trust Index©调查系统，从而避免出现重复性技术问题。',
          'TEXTO0_PARTE_2':'对于组织协作者接收并响应调查，必须遵守并验证每个技术要求。 否则，很可能会出现诸如阻塞和/或界面之类的复杂情况，从而导致协作者无法接收和响应调查。',
          'SUB_TITULO3':'贡献者（最终用户）要求',
          'SUB_TITULO4':'申请条件',

          'SUB_TITULO2_CARCA':'PlataformaCulturalGo®5.0',
          'TEXTO0_PARTE_1_CARCA':'本文档旨在告知CulturalGo®平台的技术要求，以确保轻松有效地访问Greate Place toWork®，Trust Index©调查系统，从而避免出现重复性技术问题。',
          'TEXTO0_PARTE_2_CARCA':'对于组织协作者接收并响应调查，必须遵守并验证每个技术要求。 否则，很可能会出现诸如阻塞和/或界面之类的复杂情况，从而导致协作者无法接收和响应调查。',
          'TEXTO0_PARTE_1_INNMO':'本文档旨在告知CulturalGo®平台的技术要求，以确保轻松有效地访问Innmotion，Trust Index©调查系统，从而避免出现重复性技术问题。',

          'TABLE_REQUERIMIENTOS' : {
            'TD_SISTEMAS': '操作系统：',
            'TD_LABEL_RECOMENDADO': '或更高（推荐）。',
            'TD_NAVEGADOR': '浏览器：',
            'TD_LABEL_SUPERIOR': '或更高。',
            'TD_LABEL_LASTVERSION': '（最新版本）。',
            'TD_LABEL_LASTVERSION_MIN': '（最新版本，最低版本12.3）。'
          },
          'TEXTO1_PARTE_1':'如果客户打算使用上面列出的操作系统以外的其他操作系统，例如LINUX，UNIX，Chrome OS，移动操作系统等版本，则客户有责任确保调查能够在其浏览器软件上正确运行。',
          'TEXTO1_PARTE_2':'由于POODLE（CVE-2014-3566）的漏洞以及Microsoft对Windows XP支持的终止，Great Place toWork®将不再支持从运行Windows XP的计算机访问我们的安全网站。 Great Place toWork®将为使用应用程序要求中列出的Chrome或Firefox浏览器版本的运行Windows XP的计算机提供支持。 其他浏览器可能仍然可以访问； 但是，将不会测试或支持这些浏览器。',
          'TEXTO1_PARTE_2_INNO':'由于POODLE（CVE-2014-3566）的漏洞以及Microsoft对Windows XP支持的终止，Innmotion将不再支持从运行Windows XP的计算机访问我们的安全网站。 Innmotion将为使用应用程序要求中列出的Chrome或Firefox浏览器版本的运行Windows XP的计算机提供支持。 其他浏览器可能仍然可以访问； 但是，将不会测试或支持这些浏览器。',
          'TEXTO2_PARTE_1':'注意：从版本5.0CuturalGo®开始，将删除对Microsoft Internet Explorer的支持',
        },
        'PASO2':{
          'TITULO': '调查认证',
          'SUB_TITULO1': 'Web服务器IP和域访问',
          'SUB_TITULO2': ' 防火墙白名单:',
          'TEXTO0_PARTE_1': '以下内容必须出现在白名单上，调查和报告站点才能在 PlatformCulturalGo®上工作:',
          'TEXTO1_PARTE_1': '重要的是，必须对以下域和IP地址授予必要的权限，以使您的员工能够访问Great Place toWork®Trust Index©调查',
          'TEXTO1_PARTE_1_INNMO': '重要的是，必须对以下域和IP地址授予必要的权限，以使您的员工能够访问 Innmotion Trust Index©调查',
          'BTN_COMPRO_CONEX':'检查连接',
          'BTN_SUCCE_CONEX':'建立连接',
          'TOOL_BTN_COMPRO_CONEX':'建设中的服务',
          'MODAL_SUCCESS_CONEX':'连接成功',
          'ETI_INTRUC_DOMA_COPY':'复制并发送此链接，以防您需要验证来自任何分散接入点的连接（不影响技术要求的验证）。',
           'BTN_INTRUC_COPY_ENLA':'复制链接',
           'MODAL_COPY_ENLA_SUCC':'链接复制成功',

           'SUB_TITULO2_CARCA': '防火墙白名单:',
           'TEXTO0_PARTE_1_CARCA': '以下内容必须出现在白名单上，调查和报告站点才能在 PlatformCulturalGo®上工作:',
           'TEXTO1_PARTE_1_CARCA': '重要的是，必须对以下域和IP地址授予必要的权限，以使您的员工能够访问Great Place toWork®Trust Index©调查',

          'TABLE_CONTEN':{
           'TH_ELEMENTO':'元件',
           'TH_REGIONM':'全球区域',
           'TH_REGIONC':'中南美地区',
           'TH_REGIONA':'亚洲地区',
           'TH_REGIONE':'欧洲地区',
           'TH_DOMINIO_PRINCIPAL':'主域',
           'TH_APLICADOR':'调查器',
           'TH_PLATAFORMA':'行政平台',
           'TH_ENVOLTURA':'网址套',
           'TH_RESULTADOS':'结果（Tableau®）',
           'TH_CULTURE':'文化审核®',
           'TH_PORTAL':'外部计数门户',
           'TH_SUBDOMINIO':'子域名',
           'TH_DIRECCION_IP':'IP地址',
           'TH_PUERTOS':'港口',
           'TH_DOMINIO':'域',
           'TEXTO1':'• 所有调查的链接都将通过URL包装器4all.gptw.global/传递，其中包含重定向到为每个公司分配的调查的站点最终地址。	',
           'TEXTO2':'• 出于安全原因，在调查期间，CulturalGo®的算法可以随时更改最终调查的URL。 因此，必须始终使用4all.gptw.global/包装器，该包装器在整个调查中都是永久的。 ',
           'TEXTO3':' 重要:',
           'TEXTO4':' 绝对不能直接访问调查链接（例如，http：//newsurvey.culturalgo.com/Ax013s203ls），因为构成调查的令牌可能会随时更改，恕不另行通知',
           'TEXTO5':' 重要:',
           'TEXTO6':' 用户必须具有对整个域的完全和无限（无限制）访问权限',
           'TEXTO7':' 邮件服务器',
           'TEXTO8':' 邮件服务器要求完全访问以下电子邮件地址:',
           'TEXTO9':' 您的邮件服务器需要以下权限，以防止将Great Place toWork®电子邮件作为SPAM发送到clasiquen。',
           'TEXTO9_INNMO':' 您的邮件服务器需要以下权限，以防止将Innmotion电子邮件作为SPAM发送到clasiquen。',
           'TABLA_CONTENT2':{
             'TD_CUENTA_CORREO':' 发件人的电子邮件帐户:',
             'TD_DOMINIO':'域:',
             'TD_IP_ADDRE_PRIM':'主要IP地址:',
             'TD_SECON_IP':'二级IP地址：',
             'TD_SUBDOMINIO':'用于重定向链接的子域（它们用于监控）：',
           },
           'TEXTO10':'•	 此配置是为了防止将电子邮件地址检测为垃圾邮件',
           'TEXTO11':'•	 邮件服务器必须能够从同一帐户接收数千封电子邮件',
           'TEXTO12':'•	 在电子邮件提供商的安全规则中，添加白名单的域，并在可能的情况下将其添加为联系人电子邮件帐户',
           'TEXTO13':'如果您需要支持，请发送消息至',
           'BTN_CONFIGURACION':'域和IP已配置',
           'BTN_ACCESO_ENCUESTA':'我进行了测试，没有任何并发症',
           'BTN_RECIBI_CORREOS':'我在收件箱中收到了电子邮件',

          }
        },
        'PASO3':{
          'TITULO':'入学考试',
          'TIT_TES_PRU_ACC_SURV':'在本节中，您将能够对通用调查进行可视化测试（与您的组织无关）:',
          'INS2_TES_PRU_ACC_SURV':'1。 点击：',
           'INS1_1_TES_PRU_ACC_SURV':'复制键',
           'INS1_TES_PRU_ACC_SURV':'2。 访问以下链接:',
           'INS3_TES_PRU_ACC_SURV':'3。 将密钥粘贴到密码单元中',
           'INS4_TES_PRU_ACC_SURV':'4。 点击登录',
          'TIT_TES_PRU_EM_PILO':'在本節中，您將可以測試郵件的接收',
           'INS1_TES_PRU_EM_PILO':'1。 输入电子邮件',
           'INS2_TES_PRU_EM_PILO':'2。 点击“发送测试邮件”按钮',
           'BTN_SE_EMA':'发送测试邮件',
           'CONTAC':'如有技术错误，请通过support@itbm.mx与我们联系，我们将很高兴为您解决',
           'WARN_TEST_EMAIL':'为了继续进行此过程，我们已向您发送了一个确认链接，该链接指向您的电子邮件地址',
           'MSJ_SUCC_EMA_':'电子邮件发送成功',
           'MODAL_WARNI_BAND':'要继续该过程，请确认已访问调查和/或接收了电子邮件',
          'MSJ_COP_CLA':'正在复制用户密钥',
          'MODAL_VERIFI_INFO':'验证信息',

          'MODAL_WARNI_EMAL':'IMPORTANT: This link should not be shared with the employees of the organization, because it is a test link in order to validate that the necessary permissions have been granted at the opening of the survey.',
          'CONTAC_CARCA':'如有技术错误，请通过soporte_ca@gptwonline.com与我们联系，我们将很高兴为您解决',
          'WARN_TEST_EMAIL_CARCA':'为了继续进行此过程，我们已向您发送了一个确认链接，该链接指向您的电子邮件地址',
          },
        'PASO4':{
          'TITULO':'验证问卷',
          'PREGUNTAS':{
            'PREGUNTA_1':'1.-¿我可以毫无问题地进行设置吗?',
            'PREGUNTA_1_INDI':'（如果您有任何问题，请指明）',
            'PREGUNTA_2':'2.-您的邮件服务器受到以下人员的信任:',
            'PREGUNTA_2_INDI1':'a) 您的内部IT团队（完全控制配置）.',
            'PREGUNTA_2_INDI2':'b) 我要求您的提供者提供票证（提及提供者的名称）',
            'PREGUNTA_3':'3.-¿您的电子邮件属于企业帐户（Gmail，Microsoft，Yahoo！等）?',
            'PREGUNTA_4':'4.-¿您是否注册了域“ gptwonline.com”，还记得您收到的电子邮件来自该域，请确保它们没有发送到垃圾邮件或垃圾邮件中?',
            'PREGUNTA_5':'5.-¿您是否有办法获取已接收电子邮件的列表（电子邮件日志）?',
            'PREGUNTA_6':'6.-¿您的协作者安装了哪些Internet浏览器? （请列出；浏览器-版本）',
            'PREGUNTA_7':'7.-¿您是否为员工授予了必要的权限才能浏览调? （如果我遇到问题，请注明）',
            'PREGUNTA_8':'8.-¿对于调查的应用，您是否计划为员工安排计算机室来回答调查?',
            'PREGUNTA_8_INDI1':'(¿如果是，请注明房间数和每间房间的设备数?)',
          },
          'BTN_VALIDAR_ENVIAR':'验证并发送',
        },
        'PASO5':{
          'TITULO': '数据隐私政策',
          'SUB_TITULO':'数据隐私政策',
          'PARRAFO1': '在CULTURALGO®平台的服务器上发送和存储的信息受到符合ISO 27001的政策和程序的保护和保护。如果对此有任何疑问，请联系您的Great Place ToWork®顾问.',
          'PARRAFO1_INNMO': '在CULTURALGO®平台的服务器上发送和存储的信息受到符合ISO 27001的政策和程序的保护和保护。如果对此有任何疑问，请联系您的Innmotion顾问.',
          'PARRAFO2':'注册商标',
          'PARRAFO3_1':'•	工作的好地方®和信任指数©',
          'PARRAFO3_2':'是美国Great Place To Work Institute的注册商标，在本文档中，这些标记仅用作参考。',
          'PARRAFO3_1_INNMO':'•	工作的好地方®和信任指数©',
          'PARRAFO3_2_INNMO':'是美国Innmotion Institute的注册商标，在本文档中，这些标记仅用作参考。',
          'PARRAFO4_1':'•	Cultural Go®, SuccessGo® ',
          // 'PARRAFO4_2':'它是InnovaciónTecnológicaB＆M S.A. de C.V.的注册商标。 墨西哥',
          'PARRAFO4_2':'以及整个 Go!® 平台是开发者的注册商标。',
          'PARRAFO5':'谢谢！!',
          'BTN_FINALIZAR':'完成并发送',
          'BTN_FINA_REQUE':'完成的技术要求',


        },
        'COPY_MESSAGE':'密钥已复制到剪贴板',
        'COMPR_CONEXI':'检查连接',
        'SUCCES_CONF_EMA':{
        'MODAL_SUCCESS':'邮件接收已通过验证',
        'MODAL_INSTRUCCI':'请关闭标签',
        },
        'FORMULARIO_TI': {
          'TAB': '流程结束',
          'TITULO': '审稿人详情',
          'SUBTITULO': '要结束该过程，请在以下表格中输入您的数据，然后单击“完成”按钮',
          'DONE': '该过程已经完成',
          'FINALIZAR': '最终确定技术要求',
          'NOTYET': 'IT 经理还没有完成流程，他将能够确认技术要求，直到 IT 经理输入他们的数据',
          'FORM': {
            'NOMBRE': '姓名',
            'MAIL': '电子邮件',
            'FECHA': '完成日期',
            'SINENVIAR': '数据尚未发送'
          },
          'MENSAJES': {
            'NOMBRE': '您尚未在指定字段中输入您的姓名',
            'GUARDANDO': '您输入的信息正在保存中，请稍等',
            'GUARDADO': '数据已正确保存'
          }
        },
          'ETI_EMPRE':'公司:',
          'CONTAC':'联系我们：',
         'CONTAC_DES':'我们有什么可以帮助你的吗？',
         'SEND_EMA':'发送消息',
         'LABEL':'描述',
         'TEX_BTN_SEND':'发送',
         'MODA_SEN_EMAI':'正在发送消息...',
         'SUCC_MODA_SEN_EMAI':'消息发送成功',

    }
  }
};
